export default __webpack_public_path__ + "images/Sagittal_View_of_the_Face.861367f258793193289cbec7760cc641.png";